import script from "./MST36_055INS.vue?vue&type=script&setup=true&lang=js"
export * from "./MST36_055INS.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__